'use strict';

var React = require('react'),
    Icon = require('../atoms/Icon'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./EditorHelp.less');

var HelpSection = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    title: React.PropTypes.string.isRequired,
    image: React.PropTypes.string.isRequired
  },

  render: function () {
    return (
      <div className='EditorHelp-section'>
        <h2 className='EditorHelp-subtitle'>
          {this.props.title}
        </h2>
        <p className='EditorHelp-paragraph'>
          {this.props.children}
        </p>
        <img className='EditorHelp-image'
             src={this.props.image} alt={this.props.title} />
      </div>
    );
  }
});

var EditorHelp = React.createClass({
  propTypes: {
    onCloseClick: React.PropTypes.func.isRequired
  },

  render: function () {
    return (
      <div className='Modal-body Modal-body--wide EditorHelp'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            How to Create a Stamp?
          </h3>
          <div onTouchTap={this.props.onCloseClick} className='Modal-close'>
            <Icon name='cross' size='small' mode='stroke' />
          </div>
        </div>
        <div className='Modal-content'>
          <div className='Modal-message'>
            <HelpSection image='//stampsy-eu-1.s3.amazonaws.com/uploads/11/10/2014/user/3/f8d790a9-804a-4045-8cee-2f225eae30fd.jpg'
                         title='1. Add Content'>
              Drag and drop images from the left sidebar and place them within content blocks. Add text and audio/video by pressing “+” button and choosing a relevant block.
            </HelpSection>

            <HelpSection image='//stampsy-eu-1.s3.amazonaws.com/uploads/11/10/2014/user/3/74cb29c2-a85f-4c1b-bb0a-29b2cbbb1232.jpg'
                         title='2. Provide Structure'>
              Combine content blocks together and provide structure for your stamp. Create any format you need by changing block combination and order.
            </HelpSection>

            <HelpSection image='//stampsy-eu-1.s3.amazonaws.com/uploads/11/10/2014/user/3/4cfcefba-0df7-4280-af03-be401ea7febb.jpg'
                         title='3. Post and Submit to Collections'>
              After you have created and previewed your stamp, submit to a relevant collection to gain instant exposure or or create a collection of your own.
            </HelpSection>
          </div>
        </div>
      </div>
    );
  },
});

module.exports = EditorHelp;


/** WEBPACK FOOTER **
 ** ./modals/EditorHelp.jsx
 **/